import { Button, Link, Tooltip } from "@mui/material";

import ShareIcon from "@mui/icons-material/Share";
import CloseIcon from "@mui/icons-material/Close";
import PlayArrow from "@mui/icons-material/PlayArrow";
import SaveIcon from "@mui/icons-material/Save";

import RevisionsList from "../components/RevisionsList";

const ButtonBar = ({
  updateButtonClicked,
  shareDiagram,
  saveData,
  database,
  projectId,
  try_callback,
}) => {
  return (
    <>
      <Button
        variant="contained"
        color="primary"
        startIcon={<PlayArrow />}
        onClick={updateButtonClicked}
      >
        Update
      </Button>
      <Button
        variant="contained"
        color="primary"
        startIcon={<SaveIcon />}
        style={{ margin: 10 }}
        onClick={saveData}
      >
        Save
      </Button>
      <RevisionsList
        revisions={[...database.projects[projectId].revisions].reverse()}
        try_callback={try_callback}
      />
      <Button
        variant="contained"
        color="primary"
        startIcon={<ShareIcon />}
        style={{ margin: 10 }}
        onClick={shareDiagram}
      >
        Share
      </Button>
      <Link to="/">
        <Tooltip title="Close diagram and return to home page">
          <Button
            variant="contained"
            color="primary"
            startIcon={<CloseIcon />}
            style={{ margin: 10 }}
          >
            Close
          </Button>
        </Tooltip>
      </Link>
    </>
  );
};

export default ButtonBar;
